import $ from 'jquery';
import _ from 'lodash-es';

const debouncedResize = _.debounce(() => {
  $(window).trigger('resize');
}, 250, { maxWait: 250 });

window.debouncedResize = debouncedResize; 

export {
  debouncedResize,
};